module.exports = {
  //登录
  loginComponent: {
    login: "登录",
    logout : "退出登录"
  },
  //用户组
  userGroup:{
    userGroupManage:"用户组管理",
    addUserGroup:"新增用户组",
    search:"请输入名称查找",
    name:"组名称",
    userNum:"成员数",
    createDate:"创建时间",
    remarks:"说明",
    user:"用户",
    human:"人",
    userList:"成员列表",
    addUser:"添加成员",
    addUserFromUserGroup:"从用户组添加",
    userName:"名称",
    userType:"用户类型",
    contactWay:"联系方式",
    joinTime:"加入时间",
    operation:"操作",
    deleteUserGroup:"删除",
    userGroupInfo:"用户组信息",
    deleteUser:"删除",
    chooseUser:'选择用户',
    choosedUser:"已选用户",
    choose:"选择",
    chooseUserGroup:'选择用户组',
    choosedUserGroup:'已选用户组',
    OrgList:'企业用户',
    perList:'个人用户',
    NotNullError:"用户组名不能为空!",
    chooseUserGroupFirst:"请先选择用户组!",
    chooseUserFirst:"请选择需要添加的用户!",
    remarksTooLong:"用户组说明长度超出限制",
    nameTooLong:"用户组名字长度超出限制"
  },
  //批量选择合同类型
  batchCreationSelectTypeComponent: {
    title:"选择合同类型",
    butTab1:"展开全部类型",
    butTab2:"共有",
    butTab3:"种类型",
    butTab4:"收起",
    titleTemplate:"选择合同模板",
    dialogTitle:"查看合同",
    dialogButTitle:"全屏预览",
    dialogOutTitle:"退出全屏",
  },
  //常用词
  defaultWords:{
    confirm:'确定',
    cancel:'取消',
    operation:'操作',
    modification:'修改',
    yes:"是",
    no:"否",
    explain:"说明",
    choice:"选择"
  },
  //业务数据项管理
  businessItem:{
    title:"业务数据项管理",
    addBusinessItem:"添加业务数据项",
    add:"添加",
    businessItemName:"数据项名称",
    inputBusinessItemName:"请输入数据项名称",
    businessItemKeyWords:"数据项关键字",
    isContractSearch:"是否作为合同查询条件",
    isERP:"是否同步至ERP系统",
    isContractInfoDetails:"是否在合同详情中展示",
    isContractList:"是否在合同列表中展示",
    isContractVariable:"是否做为合同变量",
    businessItem:"业务数据项",
    descriptionPlaceholder:"请输入数据项名称，其将作为数据项在平台内显示的名称",
    keywordPlaceholder:"请输入数据项关键字，关键字将不作为与业务系统和ERP系统集成时的标识字符",
    whenChoose:"当本项选择为",
    doneSearch:"时，该项业务数据将会作为合同查询的条件",
    doneERP:"时，平台将合同同步至ERP系统时，会将该业务数据值同步至ERP系统",
    doneList:"时，合同列表中将会展示该项业务数据",
    doneDetails:"时，在合同详情查看页面中将展示该项业务数据",
    errorMessage_description:'请输入业务数据项名称',
    errorMessage_keyword:'请输入数据项关键字',
    errorMessage_isErp:'请选择是否同步至ERP',
    errorMessage_isQuery:'请选择是否作为合同查询条件',
    errorMessage_isShowList:'请选择是否在合同列表中展示',
    errorMessage_isShowDetail:'请选择是否在合同详情中展示',
    errorMessage_length:'长度在 1 到 50 个字符',
    updateBusinessItem:"修改业务数据项",
    choice:"选择",
    operation:"操作",
  },
  //管理员界面->用户管理
  adminUserManagement:{

    //管理员界面->用户管理->用户管理
    userManagement:{
      userTitle:'用户管理',
      updateTitle:"修改用户信息",
      addBtnInternalUsers:'新增内部用户',
      addBtnExternalIndividuals:'新增外部个人',
      addBtnExternalEnterprise:'新增外部企业',
      tabInternalUsers:'添加内部用户',
      tabExternalIndividuals:'添加外部个人用户',
      tabExternalEnterprise:'添加外部企业用户',
      loginName: "登录名:",
      name:"姓名:",
      userType:'用户分类',
      company:"归属公司",
      Telephone:'电话',
      phone:'手机',
      type:"类型",
      role:"角色",
      state:"状态",
      operation:"操作",
      pleaseInputName:"请输入姓名",
      pleaseInputPhone:"请输入手机号码",
      pleaseInputLoginName:"请输入登录名(工号)",
      pleaseInputPassword:"请输入密码",
      pleaseInputPasswords:"请确认密码",
      pleaseInputAffiliate:"请选择所属机构",
      pleaseInputCode:"请输入编码",
      pleaseInputIDNumber:"请输入身份证",
      pleaseInputEmail:"请输入邮箱",
      pleaseInputLoginNames:"请输入登录名",
      //添加内部用户
      addInternalUsers:{
        name:"姓名",
        phone:"手机号码",
        loginName:"登录名(工号)",
        password:"密码",
        passwords:"确认密码",
        Affiliate:"所属机构",
        business:"业务范围",
        HaveRole:"拥有角色",
        DataAccess:"数据访问权限",
      },
      addExternalIndividuals:{
        code:"编码:",
        name:"名称:",
        IDNumber:"身份证:",
        phone:"手机号码:",
        email:"邮箱:"
      }
    },


    //管理员界面->用户管理->用户审核
    userAuditList:{
      title:"用户待审核列表",
      seachName:"企业名称",
      seachContactName:"法人姓名",
      seachAuthstate:"审核状态",
      AuthenticationType:"认证类型",
      corporationIdnum:"法人身份证号",
      corporationPhone:"法人手机号",
      authstate:"审核状态",
      updateUserAudit:{
        updateTitle:"修改用户待审核",
        enterpriseCertificatesType:'企业证件类型',
        representativeName:"法人代表姓名",
        representativeIDnumber:"法人代表身份证",
        representativePhone:"法人代表手机号",
        Photo:"企业证件照",
        certificatePhoto:'企业授权委托书',
        email:"邮箱地址",
        detailedAddress:"详细地址",
        contactsName:"经办人姓名",
        contactsIDnumber:"经办人身份证",
        contactsPhone:"经办人手机号",
        auditOpinion:'审核意见',
        verificationResults:"证件验证结果",
      }
    },


    //管理员几面->系统管理->合同编号
    contractNumberList:{
      title:"合同编号规则",
      codeAddBtn:"新增",
      rulesName:"合同规则名称",
      contractType:"合同类型",
      settingRuleItems:'设置规则项',
      remarks:"备注",
    },

    //管理员界面->系统管理->角色管理
    roleManage:{
      title:"角色管理",
      subTitle:"添加/修改角色",
      roleName:'角色名称',
      sort:"序号",
      userType:"用户类型",
      remaks:"备注",
      roleJurisdiction:"角色权限",
    },

    //管理员界面->系统管理->系统设置
    settingManagement:{
      title:"系统设置",
      addBtn:"新增参数",
      parameterName:"参数名称",
      parameterKeyword:"参数关键字",
      parameterValue:"参数值",
      DefaultValue:"默认值",
      remaks:"备注",
      parameterInfo:"参数信息",

    },

    //管理员界面->系统管理->合同统计
    contractStatistics:{
      title:"合同统计",
      signingName:"签约人名称",
      signingTime:"签约时间",
      contractName:"合同名称",
      contractCode:"合同编号",
      Affiliate:"所属机构",
      handleName:"经办人名称",
      contractState:"合同状态",
      statisticalTerms:"统计项",
      StatisticsType:"按类型统计",
      StatisticsTime:"按时间统计",
      StatisticsDay:"按日统计",
      StatisticsWeek:"按周统计",
      StatisticsMonth:"按月统计",
      StatisticsYear:"按年统计",

      sort:"序号",
      type:"类型",
      num:"数量"
    },

    //管理员界面->系统管理->字典管理
    dictManage:{
      title:"字典管理",
      subTitle:"添加/修改字典",
      addBtn:"添加",
      description:"字典描述",
      dictName:"字典名称",
      dictValue:"字典值",
      dictValueDescription:"字典值描述",
      sort:"排序号",
    },

    //管理员界面->系统管理->字典管理
    logManage:{
      title:"日志管理",
      operationMode:"操作模式",
      operationType:"操作类型",
      requestUri:"请求地址",
      remoteAddr:"IP地址",
      createDate:"创建时间",
      exception:"异常",
      typeName:'模块',
      //用户日志
      loginName:'用户名',
      companyName:'姓名/公司名称',
      operateResult:'操作结果',
      operateTime:'操作时间',

      //合同
      contractName:'合同名称',
      contractCode:'合同编号',
      operatorName:'操作人',
    },

    //管理员界面->系统管理->合同权限设置
    contractPrivilegeSetting:{
      title:"合同查看权限列表",
      addBtn:"新增",
      name:"姓名",
      viewableInstitutions:"可查看机构",
      viewableType:"可查看合同类型",
      contractTypeList:"机构合同类型列表",
      contractType:"合同类型",
      settingContract:"设置合同权限",
      contractTypeMultiple:"已选可查看机构对应的合同类型",
    }
  }

};



// WEBPACK FOOTER //
// ./src/language/zh_CN.js